import React, {ReactNode} from 'react'
import {Trans, useTranslation} from "react-i18next";
import './FacialInstructions.sass'
import { Box } from '@mui/material';
import { FaRegSmile } from "react-icons/fa";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { MdOutlineWbSunny } from "react-icons/md";
import { IoIosQrScanner } from "react-icons/io";
import { IoCameraOutline } from "react-icons/io5";
import { BASE } from '../../basedata/constants'
import { useLocation } from 'react-router-dom'
import Illustration from '../Illustration/Illustration'

interface Props {
    handleCloseInstructions: (result?: any) => void;
    children?: React.ReactNode;
    togglePanel: () => void;
    hideFrameImage?: boolean;
}

// well, sthepany needs to work on this
const WaIoCameraOutline = IoCameraOutline as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaIoIosQrScanner = IoIosQrScanner as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaMdOutlineWbSunny = MdOutlineWbSunny as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaIoIosCloseCircleOutline = IoIosCloseCircleOutline as React.ComponentType<React.SVGProps<SVGSVGElement>>;
const WaFaRegSmile = FaRegSmile as React.ComponentType<React.SVGProps<SVGSVGElement>>;

const FacialInstructions = ({handleCloseInstructions, togglePanel, hideFrameImage, children}:Props) => {
    const { t } = useTranslation();
    const location = useLocation();

    const isPage = location.pathname.includes('/instructions');

    return (
        <div className="instructions-content">
            <h1 className="instructions-content-title">{t("capture_face.title")}</h1>
            {!hideFrameImage && (
                <Illustration src='/ilustra-foto-dicas.png' alt={t("capture_face.instructions")} />
            )}
            <ul>
                <li className="instruction-item">
                    <span className="number-instruction"><WaFaRegSmile /></span>
                    <div className="instruction-content">
                    <p className="instruction-title">{t("facial_step.step_1")}</p>
                    <p className="instruction-text">
                        <Trans i18nKey="facial_step.tip_1" components={{ bold: <strong /> }} />
                    </p>
                    </div>
                </li>
                <li className="instruction-item">
                    <span className="number-instruction with-border"><WaIoIosCloseCircleOutline /></span>
                    <div className="instruction-content">
                    <p className="instruction-title">{t("facial_step.step_2")}</p>
                    <p className="instruction-text">
                        <Trans i18nKey="facial_step.tip_2" components={{ bold: <strong /> }} />
                    </p>
                    </div>
                </li>
                <li className="instruction-item">
                    <span className="number-instruction"><WaMdOutlineWbSunny /></span>
                    <div className="instruction-content">
                    <p className="instruction-title">{t("facial_step.step_3")}</p>
                    <p className="instruction-text">
                        <Trans i18nKey="facial_step.tip_3" components={{ bold: <strong /> }} />
                    </p>
                    </div>
                </li>
                <li className="instruction-item">
                    <span className="number-instruction"><WaIoIosQrScanner /></span>
                    <div className="instruction-content">
                    <p className="instruction-title">{t("facial_step.step_4")}</p>
                    <p className="instruction-text">
                        <Trans i18nKey="facial_step.tip_4" components={{ bold: <strong /> }} />
                    </p>
                    </div>
                </li>
            </ul>
            {window.location.pathname.includes('/instructions') && (
              <div className="button-container">
                  <button className="retry-button" onClick={() => {
                  document.querySelector('.instructions-content')?.scrollTo({ top: 0, behavior: 'smooth' });
                  handleCloseInstructions();
                  }}>
                  <span className="camera-wrapper">
                      <WaIoCameraOutline />
                      {t("capture_face.take_photo")}
                  </span>
                  </button>
              </div>
            )}
            {!isPage && (
              <footer className="footer-instructions">
                <img 
                  src={ BASE.company.bepassMobileLogo}  
                  alt={BASE.company.name}
                  className="footer-logo"
                />
              </footer>
            )}
        </div>
    );
};
export default FacialInstructions